/**
 * Created by zhaoyue on 2020/7/17 11:25 上午
 * 通用工具
 */
import {Toast} from "vant";
import sensors from "sa-sdk-javascript";

declare const KJUR: any;

// 获取url上的参数
export function getQueryString(key: string) {
  const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
  try {
    const r = window.location.href.split("?")[1].match(reg);
    if (r != null) return decodeURI(r[2]);
    return "";
  } catch (err) {
    // console.log(err)
  }
}

/**
 * 添加神策自定义埋点埋点
 * 因为缺少dom的相关信息，不推荐用此埋点了，以后用webClick方式的埋点
 * @param: eventName 事件名称
 * @param: eventParams 参数
 */
export function addSensorsTrack(eventName: any, eventParams = {}) {
  console.log(``)
  try {
    sensors.track(eventName, eventParams);
  } catch (e) {
    console.error(e);
  }
}

/**
 * 神策代码埋点触发元素点击事件
 * 文档 https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all_use-7545350.html#id-.%E5%85%A8%E5%9F%8B%E7%82%B9(Web)v1.13-%E4%BB%A3%E7%A0%81%E5%9F%8B%E7%82%B9%E8%A7%A6%E5%8F%91%E5%85%83%E7%B4%A0%E7%82%B9%E5%87%BB%E4%BA%8B%E4%BB%B6
 * @param eleTarget 点击的dom元素
 * @param customProps 自定义属性
 * @param fnCallback 回调
 */
export function sensorsWebClick(eleTarget: any, customProps?: any, fnCallback?: any) {
  if (!eleTarget.target) {
    return console.warn('点击的dom元素错误')
  }
  try {
    sensors.quick('trackAllHeatMap', eleTarget.target, {
      customEvent: 'webCustomButtonClick',
      ...customProps
    }, fnCallback);
  } catch (e) {
    console.error(e);
  }
}

/**
 * 判断是否在GoFunApp中
 */
export function isInGoFunApp() {
  const isInApp = navigator.userAgent.includes("gofun");
  console.log("是否在GoFunApp环境", isInApp);
  return isInApp;
}

/**
 * 获取Token
 * 来源可能是四种情况
 * 1.获取来自GoFun App里的token
 * 2.获取来自url上的token
 * 3.获取来自sessionStorage里的token
 * 4.获取来自localStorage里的token
 */
export function getToken() {
  let token = "";
  const urlToken = getQueryString("token");
  const sessionToken = sessionStorage.getItem("token");
  const localToken = localStorage.getItem("token");
  if (isInGoFunApp()) {
    // app放在userAgent里的token
    const ua = top.navigator.userAgent;
    token = JSON.parse(ua.split("###")[0]).token;
  } else if (urlToken) {
    token = urlToken;
  } else if (sessionToken) {
    token = sessionToken;
  } else if (localToken) {
    token = localToken;
  } else {
    console.log("其他方式获取的token");
  }
  return token;
}

/**
 * 判断是否为ios系统
 */
export function checkIsIOS() {
  const uAgent = navigator.userAgent;
  const isiOS = !!uAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // iOS终端
  return isiOS;
}

/**
 * 判断是否为android系统
 */
export function checkIsAndroid() {
  const uAgent = navigator.userAgent;
  const isAndroid =
    uAgent.indexOf("Android") > -1 || uAgent.indexOf("Adr") > -1; // android终端
  return isAndroid;
}

export function checkIsWeixin() {
  const ua = window.navigator.userAgent.toLowerCase();
  const isWeixin = ua.match(/MicroMessenger/i) + "" === "micromessenger";
  if (isWeixin) {
    return true;
  } else {
    return false;
  }
}

/**
 * 生成一共n位的随机数
 * @param n
 */
function randomString(n: number) {
  const str = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";
  for (let i = n; i > 0; --i) {
    result += str[Math.floor(Math.random() * str.length)];
  }
  return result;
}

/**
 * 获取jwt
 * 首先引入 jsrsasign-latest-all-min.js
 * oPayload中增加nonce字段，规则是项目名+10位随机字符串，例如nonce:app5_9AVL2023UU
 */
export function getJwtSafeCode() {
  const iat = Math.floor(new Date().getTime() / 1000);
  let iss = "",
    sec = "";
  if (process.env.NODE_ENV === "pre" || process.env.NODE_ENV === "dev_pre") {
    // 预发布环境网关配置
    iss = "G3FByOaFJyIdFmZspWePZEF54Mcj2sfP";
    sec = "JZBEuJoNm1ggR3SfgqQK1t5QUiHNSiVJ";
  } else {
    // 没有匹配到具体环境的按照生产环境网关配置
    iss = "9wGa0Wyip4Q7BDNdC4d4J0eCmUXTZ1ZO";
    sec = "iOWORRnA1sJ7peVTFk72FgKwmuWHKDPQ";
  }
  const oHeader = {
    alg: "HS256",
    typ: "JWT"
  };
  const nonce = "App5_" + randomString(10);
  const oPayload = {
    iss: iss,
    iat: iat,
    nbf: iat - 5,
    exp: iat + 60,
    nonce: nonce
  };
  const sHeader = JSON.stringify(oHeader);
  const sPayload = JSON.stringify(oPayload);
  let safeCode = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, sec);
  safeCode = "GoFunBearer " + safeCode;
  return safeCode;
}

// 获取API地址
export function getApiUrl() {
  return process.env.VUE_APP_API_ROOT_PROXY;
}

/**
 * 高德获取定位信息
 * cityCode和cityName
 * 注意要在https协议下才可以正常使用，http授权很大概率会被拒绝
 */
declare let AMap: any;

export function getLocationInfo() {
  console.time("高德定位");
  return new Promise((resolve, reject) => {
    const amapScript = document.createElement("script");
    amapScript.src =
      "//webapi.amap.com/maps?v=1.4.8&key=228a2d3b4f2c142386aa8b6ad900df52";
    document.body.append(amapScript);
    amapScript.onload = () => {
      AMap.plugin("AMap.Geolocation", () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: "RB", //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        console.log("开始进行高德高精度定位...");
        geolocation.getCurrentPosition((status: any, result: any) => {
          if (status === "complete") {
            console.log("高德定位成功", result);
            console.timeEnd("高德定位");
            sessionStorage.setItem(
              "cityCode",
              result.addressComponent.citycode
            );
            sessionStorage.setItem("adCode", result.addressComponent.adcode);
            resolve(result);
          } else {
            Toast("获取定位失败");
            console.log("高德定位失败", result);
            console.timeEnd("高德定位");
            reject(result);
          }
        });
      });
    };
  });
}
